import pick from "lodash/fp/pick";
import isUndefined from "lodash/fp/isUndefined";

class Controller {
  constructor($injector, $stateParams) {
    "ngInject";

    this.$stateParams = $stateParams;

    this.Events = $injector.get("Events");
    this.Bustype = $injector.get("Bustype");
    this.Messages = $injector.get("Messages");
    this.City = $injector.get("City");
    this.BustypeTransforms = $injector.get("BustypeTransforms");
    this.sections = $injector.get("Sections").settingsSections;

    this.onUpdate = this.Events.getUpdateEvent("bustype");
    this.onUpdateBusType = this.onUpdateBusType.bind(this);
  }

  $onInit() {
    const request = this.Bustype.get(this.$stateParams.id);
    request.$promise.then((response) => {
      this.bustype = this.BustypeTransforms.justify(response);

      this.City.getRideCategory({ city: this.$stateParams.id }).$promise.then(
        (response) => {
          if (response.hits) {
            this.rideCategoryList = response.hits.map((item) => ({
              name: item._id,
              title: `${item._source.service_type} (${item._source.ride_type})`,
            }));
          }
        }
      );

      this.Bustype.getVehicleTypes().$promise.then((response) => {
        this.vehicleTypeResponse = response;
        const _vehicleTypes = pick(["bus", "car"])(response);
        if (_vehicleTypes) {
          this.vehicleTypes = Object.keys(_vehicleTypes).map((key) => ({
            title: key,
            name: key,
          }));
        }

        if (this.bustype.vehicle_type) {
          const _vehicleMakes = this.vehicleTypeResponse[
            this.bustype.vehicle_type.value
          ];
          this.vehicleMakes = Object.keys(_vehicleMakes).map((key) => ({
            title: key,
            name: key,
          }));
        }

        if (this.bustype.vehicle_type && this.bustype.make) {
          const _vehicleModel = this.vehicleTypeResponse[
            this.bustype.vehicle_type.value
          ][this.bustype.make.value];

          this.vehicleModel = _vehicleModel.map((key) => ({
            title: key,
            name: key,
          }));
        }
      });
    });

    this.Events.on(this.onUpdate, this.onUpdateBusType);
  }

  onUpdateBusType(options) {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;

    const params = {};
    params[options.key] = isUndefined(options.value)
      ? options.name
        ? options.name._id
        : null
      : options.value;

    this.Bustype.updateAction(this.$stateParams.id, params).$promise.then(
      () => {
        this.bustype[options.key].isDisabled = true;
        this.Events.emit(
          showNotificationEvent,
          this.Messages.updateMessage("bustype", options.key)
        );
      },
      (response) => this.Events.emit(errorEvent, response.data)
    );
  }

  onSaveBusType() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;

    const busTypeValues = pick([
      "city",
      "label",
      "seats",
      "max_seats",
      "notes",
      "make",
      "model",
      "description",
      "vehicle_type",
    ])(this.bustype);

    const params = Object.keys(busTypeValues).reduce(
      (acc, val) => ({
        ...acc,
        [val]: busTypeValues[val].value || busTypeValues[val]._id,
      }),
      {}
    );

    params.is_ac = this.bustype.is_ac.value;
    params.ride_category =
      typeof this.bustype.ride_category === "object"
        ? this.bustype.ride_category._id
        : this.bustype.ride_category;

    params.make =
      typeof this.bustype.make === "object"
        ? this.bustype.make.value
        : this.bustype.make;

    params.vehicle_type =
      typeof this.bustype.vehicle_type === "object"
        ? this.bustype.vehicle_type.value
        : this.bustype.vehicle_type;

    this.Bustype.updateAction(this.$stateParams.id, params).$promise.then(
      () => {
        this.Events.emit(
          showNotificationEvent,
          this.Messages.updateMessage("bustype", "changes")
        );
        this.isBusTypeFormDirty = false;
      },
      (response) => this.Events.emit(errorEvent, response.data)
    );
  }

  onBusTypeChange() {
    this.isBusTypeFormDirty = true;
  }

  onSelectVehicleType(type) {
    const _vehicleMakes = this.vehicleTypeResponse[type];
    if (_vehicleMakes) {
      this.vehicleMakes = Object.keys(_vehicleMakes).map((key) => ({
        title: key,
        name: key,
      }));
    }
  }

  onSelectVehicleMake(make) {
    const vehicleType =
      this.bustype.vehicle_type &&
      (this.bustype.vehicle_type.value || this.bustype.vehicle_type);
    const _vehicleModel = this.vehicleTypeResponse[vehicleType][make];

    this.vehicleModel = _vehicleModel.map((key) => ({
      title: key,
      name: key,
    }));
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bustype/bustype.controller.js